import { useMemo } from 'react';
import { useQuery } from '@apollo/client/react';
import get from 'lodash/get';
import {
  TotalCO2SavingsReportDocument,
  type TotalCO2SavingsReportQuery,
} from 'graphql/generated/graphql';

/** The savings per measure (new_windows, heating_system, ...) and `__typename`. */
export type TTotalCO2SavingsReport = TotalCO2SavingsReportQuery['totalCO2SavingsReport'];

/** The savings of one measure. */
export type TCO2SavingsCategory = TTotalCO2SavingsReport['new_windows'];

const useTotalCO2SavingsReport = (): [TTotalCO2SavingsReport | null, boolean] => {
  const { data, loading } = useQuery(TotalCO2SavingsReportDocument);

  const totalCO2SavingsReport = useMemo(() => get(data, 'totalCO2SavingsReport', null), [data]);

  return [totalCO2SavingsReport, loading];
};

export default useTotalCO2SavingsReport;
